import 'react-app-polyfill/stable';
import root from './root';

root();
import('./addons').then((addons) => { addons.default(); });
